/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Mem_S3Inputs */

const en_mk_tut_mem_s3 = /** @type {(inputs: Mk_Tut_Mem_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A good example: *Never write “cheap”, write “value”*. A bad one: *Write well* — too vague to obey.`)
};

const id_mk_tut_mem_s3 = /** @type {(inputs: Mk_Tut_Mem_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contoh yang bagus: *Jangan pakai kata "murah", pakai "hemat"*. Contoh yang buruk: *Tulis yang bagus* — terlalu kabur untuk dipatuhi.`)
};

/**
* | output |
* | --- |
* | "A good example: *Never write “cheap”, write “value”*. A bad one: *Write well* — too vague to obey." |
*
* @param {Mk_Tut_Mem_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_mem_s3 = /** @type {((inputs?: Mk_Tut_Mem_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Mem_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_mem_s3(inputs)
	return en_mk_tut_mem_s3(inputs)
});